<template>
  <div class="Retail-landing-page">
    <RetailNavbar style="position: fixed; top: 0; width: 100%; z-index: 5;"></RetailNavbar>

    <div class="NewRetailPage">
      <div class="section1">
        <div class="inner inner-left">
          <div class="text-sec left">
            <h1 class="first-h1">Look Before You Invest</h1>
            <p class="first-p">
              StockAnts is a Marketplace for Price Estimates
            </p>

            <div class="track-list" style="width: 550px">
              <div class="first-div">
                <div class="flex top-margin-40 bottom-margin-20; align-content:center">
                  <button class="signup-btn btn-secondary-theme-filled"
                    @click="goToLink('/experts-past-recommendations')"
                    v-if="!currentUrl.includes('blinkx.stockants.com')">
                    Get Access Now
                  </button>

                  <p class="paragraph-works"
                    style="margin-left: 10px; font-weight: 500; font-size: 13px;text-transform: capitalize;">
                    Check How Its Works
                  </p>
                  <img style="width:25px; height:25px; margin-left:10px; cursor: pointer;"
                    src="../assets/images/Youtube Icon.png" alt="YouTube" @click="videoDialog = true" />
                </div>
               <div v-if="currentEnvironment.utm_source !== 'SS Corporate'">
                <div style="margin-top: 30px">
                  <p class="support-p" style="font-weight: 500px; font-size: 14px; font-weight: 500; ">
                    Supported on India's largest brokers
                  </p>
                </div>
                <div class="flex top-margin-20 bottom-margin-10">
                  <div class="partners-logo" style="display:flex; width:45px; height:45px;">
                    <img src="../assets/images/logo/Group 5435.svg" alt="" />
                    <img src="../assets/images/logo/Paytm.svg" alt="" />
                    <img src="../assets/images/logo/Dhan.svg" alt="" />
                    <img src="../assets/images/logo/Nuvama.svg" alt="" />
                    <a href="#partners" style="text-decoration: none;">
                      +More
                    </a>
                  </div>
                </div>
                </div>
               </div>
            </div>
          </div>

          <div class="img-sec">
            <div data-aos="flip-right" data-aos-duration="1000" data-aos-delay="500">
              <img src="../assets/images/Landing-page-img.jpeg" alt="" class="build-img" />
            </div>
          </div>
        </div>
      </div>

      <div style="align-items:center; margin-left:30px;">
        <div class="second-div">
          <div class="flex top-margin-40 bottom-margin-20; align-content:center">
            <button class="signup-btn btn-secondary-theme-filled" @click="goToLink('/experts-past-recommendations')"
              v-if="!currentUrl.includes('blinkx.stockants.com')">
              Get Access Now
            </button>

            <p class="paragraph-works" style="margin-left: 10px; font-weight: 500; font-size: 10px;">
              Check How Its Works
            </p>
            <img style="width: 20px; height: 20px; margin-left: 10px; cursor: pointer;"
              src="../assets/images/Youtube Icon.png" alt="YouTube" @click="videoDialog = true" />
          </div>

          <div v-if="currentEnvironment.utm_source !== 'SS Corporate'">
          <div style="margin-top: 5px;">
            <p class="support-p" style="font-weight: 600px; font-size: 12px;float:left">
              Supported on India's largest brokers
            </p>
          </div>
          &nbsp;
          <div class="flex top-margin-20 bottom-margin-10">
            <div class="partners-logo" style="display:flex; width:32px; height:32px">
              <img src="../assets/images/logo/Group 5435.svg" alt="" />
              <img src="../assets/images/logo/Paytm.svg" alt="" />
              <img src="../assets/images/logo/Dhan.svg" alt="" />
              <img src="../assets/images/logo/Nuvama.svg" alt="" />
              <a href="#partners" style="text-decoration: none;">+More</a>
            </div>
          </div>
          </div>
        </div>
      </div>

      <div class="container">
        <div class="section-2">
          <div class="sec1" style=" padding-left:10px; margin-left:10px">
            <p>Get Bundle of SEBI Experts at</p>
            <h1>One Click</h1>
          </div>

          <div class="sec-2wrap" style="display:flex;">
            <div class="sec2" style="padding-left: 10px; padding-top:10px; padding-bottom:10px;">
              <div class="flex" style="padding: 0px">
                <h1>+60</h1>
                <p>
                  <span>SEBI Registered <br />Research Analyst</span>
                </p>
              </div>
            </div>

            <div class="sec3" style="padding-left: 10px; padding-top:10px; padding-bottom:10px;">
              <div class="flex" style="padding: 0px; ">
                <h1>+1k</h1>
                <p>
                  <span class="text-left">Live <br />Recommendations</span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Banner Section Positioned Above the Content -->
      <div class="chat-banner-launch">
    <!-- Web View Image -->
    <img
      src="../assets/images/NewRetailLandingPage/Home Page banner (Website).svg"
      alt="Web Chat Banner"
      class="banner-image web-view" @click="goToChat()"
    />

    <!-- Mobile View Image -->
    <img
      src="../assets/images/NewRetailLandingPage/Home Page banner (Mobile).svg"
      alt="Mobile Chat Banner"
      class="banner-image mobile-view" @click="goToChat()"
    />
  </div>

      <div class="section-3" style="margin-top: 60px; background-color: #f7fbff">
        <div class="div-heading text-center">
          <p style="
            color: #000000;
            font-size: 18px;
            font-weight: 500;
          ">
            Investing in Equity & Options made easy
          </p>
          <h1 style="
            color: #2D2E8D;
            font-size: 30px;
            text-transform: capitalize;
            margin-top:0px;
            margin-bottom:20px
          ">
            Begin Your Journey In 3 Easy Steps
          </h1>
        </div>
      </div>

      <div class="steps flex-center" :style="{
        height: '260px',
        marginTop: '0px',
        marginBottom: '20px',
      }">
        <img v-if="windowWidth >= 768" src="../assets/images/NewRetailLandingPage/3 steps (1) (2).svg" alt=""
          style="margin-top:50px" />
        <img v-else src="../assets/images/NewRetailLandingPage/3 steps mobile view.svg" alt="" />
      </div>

      <div class="carousel-div" style="margin-top:10px">
        <div class="section1" style="margin-bottom:0px; margin-top:0px">
          <div class="inner inner-left">
            <div class="text-sec left">
              <div class="sec33">
                <h1>
                  30 Sec DIY
                </h1>
                <p>
                  With Experts Live Recommendations
                </p>
              </div>
              <div class="first-div">
                <button class="signup-btn btn-secondary-theme-filled" @click="goToLink('/experts-past-recommendations')"
                  v-if="!currentUrl.includes('blinkx.stockants.com')">
                  Get Access Now
                </button>
              </div>
            </div>

            <div class="img-sec">
              <div class="Carousel-desktop">
                <el-carousel indicator-position="outside" :autoplay="true" @change="updateText">
                  <el-carousel-item>
                    <div class="emp-card-section">
                      <img src="../assets/images/NewRetailLandingPage/Track (1).svg" alt="Image1"
                        style="height:320px; width:90%" />
                    </div>
                  </el-carousel-item>

                  <el-carousel-item>
                    <div class="emp-card-section">
                      <img src="../assets/images/NewRetailLandingPage/Trust (2).svg" alt="Image2"
                        style="height:320px; width:95%" />
                    </div>
                  </el-carousel-item>

                  <el-carousel-item>
                    <div class="emp-card-section">
                      <img src="../assets/images/NewRetailLandingPage/Trade (3).svg" alt="Image3"
                        style="height:400px; width:95%" />
                    </div>
                  </el-carousel-item>
                </el-carousel>
              </div>

              <div class="carousel-text" v-show="selectedImage === 1">
                <h1>Track</h1>
                <p>
                  Professionally-created ready to use recommendations for retail
                  users
                </p>
              </div>

              <div class="carousel-text" v-show="selectedImage === 2">
                <h1>Trust</h1>
                <p>
                  Trust Research and Opinions backed by performance track
                  record.
                </p>
              </div>

              <div class="carousel-text" v-show="selectedImage === 3">
                <h1>Trade</h1>
                <p>
                  Trade with your broker based on Aggregated Market Sentiment
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Button for mobile view -->
      <div class="second-div">
        <button class="signup-btn btn-secondary-theme-filled mob-btn" @click="goToLink('/experts-past-recommendations')"
          v-if="!currentUrl.includes('blinkx.stockants.com')">
          Get Access Now
        </button>
      </div>

      <div class="section-3" style="margin-top: 50px; height: 90px; background-color: #f7fbff">
        <div class="div-heading">
          <h1>
            Value Added Services
          </h1>
        </div>
      </div>

      <div class="get-overview" style="margin-top:50px">
        <div class="section1">
          <div class="inner inner-left">
            <div class="img-sec">
              <div data-aos="flip-right" data-aos-duration="1000" data-aos-delay="500">
                <img src="../assets/images/NewRetailLandingPage/Brief Overview.svg" alt="" class="build-img" />
              </div>
            </div>
            <div class="text-sec left">
              <div class="stock-overview">
                <h1>
                  <span style="color: #2D2E8D;"><strong style="margin:5px; color: #E2E3FF; ">01</strong></span>Get Brief
                  Overview Of Stock Through
                </h1>
                <!-- <div class="screeners" style="margin-left:80px; width:320px; flex-wrap:nowrap"> -->
                <p style="color: #000">
                  <img style="width:20px; height:20px; margin-right:10px" src="../assets/images/Tick Icon.svg" alt="" />
                  Market Sentiment
                </p>
                <p style="color: #000">
                  <img style="width:20px; height:20px; margin-right:10px" src="../assets/images/Tick Icon.svg" alt="" />
                  Fundamental Screeners
                </p>
                <p style="color: #000;">
                  <img style="width:20px; height:20px; margin-right:10px" src="../assets/images/Tick Icon.svg" alt="" />
                  Technical Screeners
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="real-tracking" style="margin-top:50px">
        <div class="section1">
          <div class="inner inner-left">
            <div class="text-sec left show-for-desktop">
              <div class="stock-overview">
                <h1>
                  <span style="color: #2D2E8D;text-align: center;"><strong
                      style="margin:5px; color: #E2E3FF;text-align: center;">02</strong></span>Price estimate tracking
                </h1>
                <p style="color: #000;">
                  Track SEBI registered experts' price estimates using
                  <span style="color: #2D2E8D;">status wheel</span>
                </p>
              </div>
            </div>

            <div class="img-sec">
              <div data-aos="flip-right" data-aos-duration="1000" data-aos-delay="500">
                <img src="../assets/images/NewRetailLandingPage/Price estimate tracking.svg" alt="" class="build-img"
                  style="float-right" />
              </div>
            </div>

            <div class="text-sec left show-for-mob">
              <div class="stock-overview">
                <h1>
                  <span style="color:#2D2E8D; text-align:center;"><strong
                      style="margin:5px; color: #E2E3FF; text-align: center;">02</strong></span>Price estimate tracking
                </h1>
                <p style="color: #000;">
                  Track SEBI registered experts' price estimates using
                  <span style="color: #2D2E8D;">status wheel</span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="brokerage" style="margin-top:50px">
        <div class="section1">
          <div class="inner inner-left">
            <div class="img-sec">
              <div data-aos="flip-right" data-aos-duration="1000" data-aos-delay="500">
                <img src="../assets/images/NewRetailLandingPage/Frame 157.svg" alt="" class="build-img" />
              </div>
            </div>
            <div class="text-sec left">
              <div class="stock-overview">
                <h1>
                  <span style="color: #2D2E8D;"><strong
                      style="margin:5px; color: #E2E3FF;text-align: center;">03</strong></span>Brokerage Calculator
                </h1>
                <p style="color: #000;">
                  Checkout Actual Potential On Trade Using The Facility Of
                  <span style="color: #2D2E8D;">Trading Cost Estimation</span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="section-3"
        style="margin-top: 50px; background: linear-gradient(180deg, #F0F7FF 0%, rgba(240, 247, 255, 0.00) 108.06%); margin-bottom:50px">
        <div class="div-heading">
          <h1>
            Our Achievements
          </h1>
          <div class="section" style="display:flex">
            <div class="sec" style="margin-left:20px; margin-right:20px">
              <h1>{{ totalRecoCount }}</h1>
              <p>Total Recommendations</p>
            </div>

            <div class="sec" style="margin-left:20px; margin-right:20px">
              <h1>{{ liveRecoCount }}</h1>
              <p>Live Recommendations</p>
            </div>

            <div class="sec" style="margin-left:20px; margin-right:20px">
              <h1>{{ totalStockCount }}</h1>
              <p>No. of Stocks Covered</p>
            </div>

            <div class="sec" style="margin-left:20px; margin-right:20px">
              <h1>{{ totalSectorCount }}</h1>
              <p>No. of Sectors Covered</p>
            </div>
          </div>
        </div>
      </div>

      <div class="text-center button-section" style="margin-top:5 0px">
        <span class="faq-title">Frequently Asked Questions</span>
      </div>

      <div class="card-container">
        <el-card class="card">
          <el-collapse>
            <el-collapse-item name="1">
              <template slot="title">
                <span class="el-collapse-item__header-text question">How can StockAnts benefit me as a retail
                  users?</span>
              </template>
              <span class="answer" style="color:black; ">StockAnts is a marketplace for price estimates. We aggregate
                price estimates of Equity & Options from SEBI registered experts
                to help retail users to make an investment decision & trade with
                their broker.</span>
            </el-collapse-item>
          </el-collapse>
        </el-card>

        <el-card class="card">
          <el-collapse>
            <el-collapse-item name="1">
              <template slot="title">
                <span class="el-collapse-item__header-text question">How to sign up on StockAnts?</span>
              </template>
              <span class="answer" style="color:black;">A retail user can sign in using broker credentials (Listed) or
                sign-up using Email or Gmail.</span>
            </el-collapse-item>
          </el-collapse>
        </el-card>

        <el-card class="card">
          <el-collapse>
            <el-collapse-item name="1">
              <template slot="title">
                <span class="el-collapse-item__header-text question">Can I trade on StockAnts? Are there any charges for
                  trading
                  directly from StockAnts?</span>
              </template>
              <span class="answer" style="color:black;">Yes, On StockAnts, you can connect your broker’s demat account
                & trade through the same. StockAnts provides this facility for
                free.</span>
            </el-collapse-item>
          </el-collapse>
        </el-card>

        <el-card class="card">
          <el-collapse>
            <el-collapse-item name="1">
              <template slot="title">
                <span class="el-collapse-item__header-text question">How can I get unlimited access of the
                  platform?</span>
              </template>
              <span class="answer">You can get unlimited & unrestricted access of SEBI Registered
                RA & RIA’s research data by subscribing to StockAnts
                platform.</span>
            </el-collapse-item>
          </el-collapse>
        </el-card>

        <button class="custom-button" @click="goToLink('/retail-side/faq')" id="partners">
          FAQs
        </button>
      </div>
        <div class="outer text-center" v-if="currentEnvironment.utm_source !== 'SS Corporate'">
        <h2 class="head" style="color:#2D2E8D; margin: 0px;">
          Partners
        </h2>
        <div class="marquee-container">
          <marquee scrollamount="15" behavior="scroll" direction="left" ref="marquee">
            <img src="../assets/images/logo/5paisa.jpeg" alt="5paisa" title="5paisa" @mouseover="pauseMarquee"
              @mouseleave="resumeMarquee" />
            <img src="../assets/images/logo/alicebluelogo.png" alt="Alice Blue" title="Alice Blue"
              @mouseover="pauseMarquee" @mouseleave="resumeMarquee" />
            <img src="../assets/images/logo/AngelOne.png" alt="Angel One" title="Angel One" @mouseover="pauseMarquee"
              @mouseleave="resumeMarquee" />
            <img src="../assets/images/logo/bigulLgLogo.svg" alt="Bigul" title="Bigul" @mouseover="pauseMarquee"
              @mouseleave="resumeMarquee" />
            <img src="../assets/images/logo/choiceLogo.png" alt="Choice" title="Choice" @mouseover="pauseMarquee"
              @mouseleave="resumeMarquee" />
            <img src="../assets/images/logo/DhanLogo.png" alt="Dhan" title="Dhan" @mouseover="pauseMarquee"
              @mouseleave="resumeMarquee" />
            <img src="../assets/images/logo/fyers.png" alt="Fyers" title="Fyers" @mouseover="pauseMarquee"
              @mouseleave="resumeMarquee" />
            <img src="../assets/images/logo/Maitra logo.png" alt="Maitra" title="Maitra" @mouseover="pauseMarquee"
              @mouseleave="resumeMarquee" />
            <img src="../assets/images/logo/NuvamaLogo.jpeg" alt="Nuvama" title="Nuvama" @mouseover="pauseMarquee"
              @mouseleave="resumeMarquee" />
            <img src="../assets/images/logo/Paytm_Money_Logo.png" alt="Paytm Money" title="Paytm Money"
              @mouseover="pauseMarquee" @mouseleave="resumeMarquee" />
            <img src="../assets/images/logo/rmoney logo.png" alt="RMoney" title="RMoney" @mouseover="pauseMarquee"
              @mouseleave="resumeMarquee" />
            <img src="../assets/images/logo/navia Logo.png" alt="Navia" title="Navia" @mouseover="pauseMarquee"
              @mouseleave="resumeMarquee" />
            <img src="../assets/images/logo/skiCapitalNew.jpeg" alt="SKI Capital" title="SKI Capital"
              @mouseover="pauseMarquee" @mouseleave="resumeMarquee" />
            <img src="../assets/images/logo/share-India PNG.png" alt="Share India" title="Share India"
              @mouseover="pauseMarquee" @mouseleave="resumeMarquee" />
            <img src="../assets/images/logo/almondz-logo (1).png" alt="Almondz" title="Almondz"
              @mouseover="pauseMarquee" @mouseleave="resumeMarquee" />
            <img src="../assets/images/logo/Ashlar.jpeg" alt="Ashlar" title="Ashlar" @mouseover="pauseMarquee"
              @mouseleave="resumeMarquee" />
            <img src="../assets/images/logo/Bajaj Logo.png" alt="Bajaj" title="Bajaj" @mouseover="pauseMarquee"
              @mouseleave="resumeMarquee" />
            <img src="../assets/images/logo/Multigain.jpeg" alt="Multigain" title="Multigain" @mouseover="pauseMarquee"
              @mouseleave="resumeMarquee" />
            <img src="../assets/images/logo/upstox logo.svg" alt="Upstox" title="Upstox" @mouseover="pauseMarquee"
              @mouseleave="resumeMarquee" />
            <!-- <img src="../assets/images/logo/BlinX Logo.png" alt="BlinX" title="BlinX" @mouseover="pauseMarquee"
              @mouseleave="resumeMarquee" /> -->
            <img src="../assets/images/logo/Parasram logo.jpg" alt="Parasram" title="Parasram" @mouseover="pauseMarquee"
              @mouseleave="resumeMarquee" />
            <img src="../assets/images/logo/enrich_money_logo.jpg" alt="Enrich Money" title="Enrich Money"
              @mouseover="pauseMarquee" @mouseleave="resumeMarquee" />
            <img src="../assets/images/logo/choiceLogo.png" alt="Choice" title="Choice" @mouseover="pauseMarquee"
              @mouseleave="resumeMarquee" />
            <img src="../assets/images/logo/Rupeezy (1).svg" alt="Rupeezy" title="Rupeezy" @mouseover="pauseMarquee"
              @mouseleave="resumeMarquee" />
            <img src="../assets/images/logo/Motisonsshares2.jpeg" alt="Motisons" title="Motisons" @mouseover="pauseMarquee"
              @mouseleave="resumeMarquee" />
            <img src="../assets/images/logo/daily gong logo.png" alt="Daily Gong" title="Daily Gong"
              @mouseover="pauseMarquee" @mouseleave="resumeMarquee" />
            <img src="../assets/images/logo/ISS Enterprise logo.jpg" alt="DailyGongPlus" title="DailyGongPlus"
              @mouseover="pauseMarquee" @mouseleave="resumeMarquee" />
            <img src="../assets/images/logo/logo_ol_company_logo.png" alt="GCL" title="GCL" @mouseover="pauseMarquee"
              @mouseleave="resumeMarquee" />
            <img src="../assets/images/logo/SmartDelta App Logo.png" alt="SmartDelta" title="SmartDelta"
              @mouseover="pauseMarquee" @mouseleave="resumeMarquee" />
            <img src="../assets/images/logo/HDFC SKY Logo.svg" alt="HDFC SKY" title="HDFC SKY" @mouseover="pauseMarquee"
              @mouseleave="resumeMarquee" />

              <img src="../assets/images/logo/Supernal Ventures Logo.svg" alt="Supernal Ventures" title="Supernal Ventures" @mouseover="pauseMarquee"
              @mouseleave="resumeMarquee" />
              <img src="../assets/images/logo/SSCorporateLogo.png" alt="SS Corporate" title="SS Corporate" @mouseover="pauseMarquee"
              @mouseleave="resumeMarquee" />
              <img src="../assets/images/logo/Findoclogo.svg" alt="Findoc" title="Findoc" @mouseover="pauseMarquee"
              @mouseleave="resumeMarquee" />
              <img src="../assets/images/logo/Aetram Logo.jpg" alt="Aetram" title="Aetram" @mouseover="pauseMarquee"
              @mouseleave="resumeMarquee" />
              <img src="../assets/images/logo/Bullforce Logo.png" alt="Bullforce" title="Bullforce" @mouseover="pauseMarquee"
              @mouseleave="resumeMarquee" />
          </marquee>
        </div>
        </div>
    </div>

    <RetailFooter></RetailFooter>

    <!-- Youtube video dialog -->
    <div id="video-section">
      <el-dialog :visible.sync="videoDialog" :before-close="videoDialogClose" center>
        <div class="iframe-container">
          <iframe id="videoId" width="100%" height="600px"
            src="https://www.youtube.com/embed/umwESJwcelY?si=J6GKzIUX_MBTJqYp" title="YouTube video player"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen></iframe>
        </div>
      </el-dialog>
    </div>

  </div>
</template>

<script>
import { serverHostName } from "../networkConfig";
import { filterCallBack } from "../mixins/filter";
import { screenSize } from "../mixins/ScreenSize.js";
import { required } from "vuelidate/lib/validators";
import { graphData } from "../mixins/BarGraphData";
import { HelperNetworkCallBack } from "../mixins/Helper";
import moment from "moment";
import RetailNavbar from "../components/RetailSideCompo/RetailNavbar.vue";
import RetailFooter from "@/components/RetailSideCompo/RetailFooter.vue";
//import axios from 'axios';
import { serverAddr } from "../networkConfig";

export default {
  name: "RetailLandingPage",

  mixins: [filterCallBack, screenSize, graphData, HelperNetworkCallBack],

  components: {
    RetailNavbar,
    RetailFooter,
  },

  data() {
    return {
      nav_title: "Expert Cover Page",
      expert_details: {},
      user_id: "",
      user_type: "",
      // user_profession: [],
      is_following: false,
      write_review_dialog_visibility: false,
      access_code_dialog_visibility: false,
      is_review_section_loading: false,
      is_recommended_experts_list_loading: false,
      review_per_page: 3,
      total_review_pages: null,
      review_current_page_no: 1,
      total_reviews: null,
      access_code: "",
      is_expert_has_access_to_dashboard: false,
      is_access_code_verifying: false,
      star_rating: null,
      review_title: "",
      review: "",
      checked: false,
      review_section_collapse: 1,
      is_expert_details_loading: false,
      is_review_submit_in_progress: false,
      review_list: [],
      page_no: 1,
      number_of_pages: null,
      page_per_entries: 3,
      active_carousel_item: 0,
      active_sub_menu_link: "STOCKS",
      active_performance: "ROI",
      active_period: "1M",
      is_roi_graph_data_available: true,
      is_success_rate_graph_data_available: true,
      is_accuracy_graph_data_available: true,
      is_reco_count_data_available: true,
      roi_graph_instance: null,
      accuracy_graph_instance: null,
      success_rate_graph_instance: null,
      reco_count_graph_instance: null,
      active_roi_inner_chart_legend: "",
      active_roi_outer_chart_legend: "",
      active_accuracy_inner_chart_legend: "",
      active_accuracy_outer_chart_legend: "",
      active_success_rate_inner_chart_legend: "",
      active_success_rate_outer_chart_legend: "",
      active_reco_count_chart_legend: "",
      total_stocks_covered: 0,
      moment: moment,
      serverHostName: serverHostName,
      showEquityDiv: true,
      showOptionsDiv: false,
      activeNames: ["1"],
      selectedImage: 1,
      totalRecoCount: "+",
      liveRecoCount: "+",
      totalStockCount: "+",
      totalSectorCount: "+",
      windowWidth: window.innerWidth,
      userProfile: {},
      currentUrl: localStorage.getItem("currentUrl")
        ? localStorage.getItem("currentUrl")
        : window.location.href,

      videoDialog: false,
      currentEnvironment: {}
    };
  },

  mounted() {
    if (localStorage.getItem("profile")) {
      this.userProfile = JSON.parse(localStorage.getItem("profile"));
    }
    // get currentEnvironment details
    if (localStorage.getItem('currentEnvironment')) {
      this.currentEnvironment = JSON.parse(localStorage.getItem('currentEnvironment'));
    }
    // after logout save currentUrl
    if (!localStorage.getItem("currentUrl") || this.userProfile) {
      this.selectUserType();
    }
    this.getAchievementsCount();

    // set usertype for redirection
    localStorage.setItem("UserType", "RETAIL INVESTOR");

    // Update window width when the component is mounted
    window.addEventListener("resize", this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
  },

  validations: {
    review_title: {
      required,
    },
    review: {
      required,
    },
    access_code: {
      required,
    },
  },

  methods: {
     goToChat() {
      const profession = this.userProfile && this.userProfile.profession;
      if (profession === 'Retail Investor') {
        this.$router.push('/expert-list');
      } else {
        this.$router.push('/chat');
      }
    },
    videoDialogClose() {
      this.videoDialog = false;
      let video = document.getElementById("videoId");
      let url = video.getAttribute("src");
      video.setAttribute("src", "");
      video.setAttribute("src", url);
    },
    getAchievementsCount() {
      serverAddr
        .get("/overview/our_achievements")
        .then((response) => {
          if (response.data.status) {
            this.totalRecoCount = `+${response.data.data.total_reco_count}`;
            this.liveRecoCount = `+${response.data.data.live_reco_count}`;
            this.totalStockCount = `+${response.data.data.total_stock_count}`;
            this.totalSectorCount = `+${response.data.data.total_sector_count}`;
          }
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
        });
    },

    handleResize() {
      this.windowWidth = window.innerWidth;
    },

    goToLink(link) {
      window.location.href = link;
    },

    updateText(index) {
      this.selectedImage = index + 1;
    },
    pauseMarquee() {
      this.$refs.marquee.stop(); // Pauses the marquee scroll
    },
    resumeMarquee() {
      this.$refs.marquee.start(); // Resumes the marquee scroll
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../css/variable.scss";
@import "../css/common.scss";

.Retail-landing-page {
  min-height: 100vh;
  margin-right: 0px;

  .signup-btn {
    width: 200px;
    height: 50px;
    border-radius: 10px;
    background: #2d2e8d;
    box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.25);
    font-size: 15px;
    font-weight: 700;
    line-height: normal;
    text-transform: capitalize;
    cursor: pointer;
  }
}

.NewRetailPage {
  margin-top: 80px;
}

.container {
  display: flex;
  justify-content: flex-end;
  //margin-bottom:40px
}

.track-list {
  width: 550px;
}

/* Default styles for both divs */
.first-div,
.second-div {
  // margin-top: 30px;
  margin-bottom: 30px;
}

//css for section 2
.section-2 {
  width: 800px;
  background: linear-gradient(90deg,
      rgba(236, 245, 255, 0.8) 61.27%,
      rgba(236, 245, 255, 0) 100%);
  //border-top-left-radius: 20px;
  //border-bottom-left-radius: 20px;
  display: flex;
  padding-top: 15px;
  padding-bottom: 15px;
  //flex-wrap: wrap;
}

.section-2 .sec1 p {
  margin-top: 5px;
  margin-bottom: 5px;
  font-size: 15px;
  font-weight: 500;
  flex-wrap: nowrap;
}

.section-2 .sec1 h1 {
  margin: 0px;
  color: #2d2e8d;
  font-size: 35px;

  font-weight: 700;
}

.section-2 .sec2 p {
  margin-top: 8px;
  margin-bottom: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.section-2 .sec2 h1 {
  margin: 0px;
  padding: 0px;
  color: #2d2e8d;
  font-size: 35px;
  font-weight: 700;
  text-transform: capitalize;
  margin-right: 10px;
}

.section-2 .sec2 span {
  display: inline-block;
  vertical-align: super;
  font-size: 15px;
  font-weight: 500;
}

.section-2 .sec3 p {
  margin-top: 8px;
  margin-bottom: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.section-2 .sec3 h1 {
  margin: 0px;
  padding: 0px;
  color: #2d2e8d;
  font-size: 35px;
  font-weight: 700;
  text-transform: capitalize;
  margin-right: 10px;
}

.section-2 .sec3 span {
  display: inline-block;
  vertical-align: super;
  font-size: 15px;
  font-weight: 500;
  //align-item: center
}

.container .section-2 .sec-2wrap {
  flex-wrap: wrap;
  //padding-left: 30px;
  padding-right: 0px;
  margin-left: 0px;
  margin-right: 50px;
}

.div-heading {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  justify-content: center;
  margin-top: 0px;
  //padding: 0 7%;
}

/* Media query for 3 steps section*/
.steps {
  height: 260px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 30px;
  //padding: 0 7%;
}

// Below css for Marquee tag
marquee {
  height: 100px;
  width: 100%;
  overflow: hidden;
  white-space: nowrap;
  box-sizing: border-box;
  padding-top: 15px;
  padding-bottom: 10px;
  justify-content: center;
}

@keyframes marquee {
  0% {
    transform: translateX(100%);
  }

  100% {
    transform: translateX(-100%);
  }
}

.outer {
  background-color: #feffe5;
  text-align: center;
  padding: 20px 0px 10px;
  // background-color: #FEFFE5;
  margin-top: 50px;
}

.marquee-container img {
  max-height: 45px;
  margin-right: 60px;
  // width: 150px;
  padding-top: 10px;
  padding-bottom: 10px;
}

.responsive-section {
  display: flex;
  flex-wrap: wrap;
  margin: 0px;
}

.text-section {
  flex: 1;
  padding: 20px;
  box-sizing: border-box;
}

.image-section {
  flex: 1;
  box-sizing: border-box;
}

img {
  //max-width: 100%;
  height: auto;
}

// css for section 1
.section1 {
  margin: 40px 0;
  padding: 0 7%;

  .inner {
    display: flex;
    align-items: center;

    .img-sec {
      width: 50%;

      //text-align: center;
      .build-img {
        width: 95%;
      }

      img {
        width: 90%;
      }
    }

    .left {
      text-align: left;
    }

    .right {
      text-align: right;
    }

    .text-sec {
      width: 50%;
    }
  }
}

.first-h1 {
  font-size: 50px;
  font-weight: 700;
  text-transform: capitalize;
  margin-bottom: 20px;
  margin-top: 20px;
}

.first-p {
  color: #000000;
  font-size: 20px;
  font-weight: 500;
  margin-bottom: 30px;
}

.partners-logo a {
  color: #2488ff;
  text-align: center;
  font-size: 13px;
  font-weight: 600;
  width: 46px;
  height: 20px;
  flex-shrink: 0;
  margin-top: 16px;
  margin-bottom: 16px;
}

.partners-logo img {
  margin-right: 10px;
}

/* Background Container Style */
.chat-banner-launch {
  width: 100%;
  margin-top: 40px;
  padding: 0;
  position: relative;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  align-items: center;
  background: none;

  .banner-image {
    width: 100%;
    max-width: 100%;
    height: auto;
    display: none;

    &.web-view {
      display: block;
    }

    &.mobile-view {
      display: none;
    }
  }
}

/* Top Aligned Features List */
.features-top {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 0px;
}

/* Left Aligned */
.text-left {
  flex: 1;
  text-align: center;
  margin-bottom: 20px;
  margin-top: 10px;

  h2 {
    margin: 0;
    font-size: 35px;
    color: white;
    white-space: nowrap;
  }
}

/* Features List Style */
.features-list-container {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.features-list {
  list-style-type: none;
  padding: 0;

  li {
    font-size: 15px;
    font-weight: 500;
    color: #ffffff;
    margin: 5px 0;
    position: relative;

    &::before {
      content: "";
      display: inline-block;
      width: 15px;
      height: 15px;
      margin-right: 10px;
      background-image: url("../assets/images/GreenTick.svg");
      /* Adjust path as needed */
      background-size: contain;
      background-repeat: no-repeat;
      background-position: center;
    }
  }
}

/* Highlighted Text Style */
.highlighted {
  font-weight: 500;
  font-size: 25px;
  color: white;
}

/* Coming Soon Banner Style */
.coming-soon-banner-container {
  margin-top: 20px;
  text-align: center;

  .coming-soon-banner {
    background-color: #f4f4f4;
    color: #333;
    padding: 10px;
    border-radius: 8px;
    font-weight: bold;
  }
}

/* Bottom Text Section */
.bottom-text {
  position: absolute;
  bottom: 10px;
  // left: 25px;
  width: calc(100% - 40px);
  font-size: 12px;
  font-weight: 500;
  color: #ffffff;
  padding: 0;
  text-align: left;
}

/* Image Right Style */
.image-right {
  flex: 1;
  text-align: center;

  .corner-image {
    max-width: 250px;
  }
}

/* Responsive Styles */
@media screen and (max-width: 968px) {

  .features-top,
  .image-right,
  .bottom-text {
    flex: none;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: 20px;
    margin-top: 10px;
  }

  .features-list {
    padding: 0;
    margin: 0;
    display: flex;
    flex-direction: column;

    li {
      text-align: left;
      font-size: 15px;
      font-weight: 500;
    }
  }

  .text-left h2 {
    font-size: 30px;
  }

  .text-left {
    margin-top: 40px;
  }

  .highlighted {
    font-size: 25px;
  }

  .bottom-text {
    position: static;
    width: 100%;
    text-align: center;
    font-size: 12px;
  }

  .banner-image {
    top: 10px;
  }
}

// Below css for our achievement section 3
.section-3 {
  margin-top: 80px;
  background-color: #f7fbff;
}

.section-3 .div-heading h1 {
  color: #2d2e8d;
  font-size: 35px;
  font-weight: 700;
}

h1 {
  color: #2d2e8d;
  margin-top: 10px;
  font-weight: 700;
  font-size: 30px;
  margin-top: 25px;
  margin-bottom: 25px;
}

// below css for section div
.section {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}

.section .sec h1 {
  margin: 0px;
  color: #2d2e8d;
  font-size: 50px;
  font-weight: 700;
  line-height: 159.523%;
}

.section .sec p {
  color: #000;
  text-align: center;

  font-size: 17px;
}

.sec2,
.sec3 {
  box-sizing: border-box;
  flex: 1;
}

.section1 .sec33 h1 {
  font-size: 35px;
  font-weight: 700;
}

.section1 .sec33 p {
  font-size: 20px;
  font-weight: 500px;
}

.emp-card-section {
  position: relative;
}

.carousel-text1,
.carousel-text2,
.carousel-text3 {
  display: none;
  color: black;
  font-size: 16px;
  text-align: center;
  margin-top: 10px;
}

.carousel-text1 {
  display: block;
}

.carousel-text2 {
  display: none;
}

.carousel-text3 {
  display: none;
}

.carousel-text h1 {
  color: #2d2e8d;
  font-size: 25px;
  font-weight: 600;
  margin-bottom: 10px;
  margin-top: 10px;
}

.carousel-text p {
  color: #656565;
  font-size: 15px;
  font-weight: 600;
}

// below css for carousel section
.section5 {
  margin: 100px 50px;

  .Carousel-mobile {
    display: none;
  }

  .image-outer {
    width: 50%;
    display: flex;
    justify-content: center;
  }

  h3 {
    font-size: 1.8rem;
    text-align: center;
    text-transform: uppercase;
  }

  .emp-card-section {
    display: flex;
    justify-content: space-around;

    .emp-card {
      max-width: 400px;
      text-align: center;
      position: relative;
      margin: 10px 20px;

      .card1 {
        height: 80px;
      }

      img {
        width: 125px;
        position: absolute;
        top: 25px;
      }
    }
  }
}

// css for faq heading
.text-center {
  text-align: center;
}

.button-section {
  margin-top: 50px;
}

.faq-title {
  font-size: 35px;
  font-weight: 700;
  line-height: 159.523%;
}

// css for collapse
.el-collapse-item__header {
  border-bottom: none !important;
}

// css for Faq button below collapse
.custom-button {
  height: 40px;
  width: 110px;
  background: rgba(255, 255, 255, 0);
  border: 0.8px solid #000;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 16px;
  cursor: pointer;
  border-radius: 10px;
  color: #000;
  font-size: 15px;
  font-weight: 500;
  line-height: 159.523%;
}

// css for 3 section of text and image
.text-sec .stock-overview h1 {
  font-size: 25px;
  font-weight: 600;
}

.text-sec .stock-overview strong {
  font-size: 60px;
  font-weight: 600px;
}

.text-sec .stock-overview span {
  font-size: 18px;
  font-weight: 700;
}

.text-sec .stock-overview p {
  font-size: 18px;
  font-weight: 500;
  padding-left: 80px;
}

/* Media query for screens above 768px */
@media (min-width: 769px) {
  .second-div {
    display: none;
  }
}

/* Media query for screens below 768px */
@media (max-width: 768px) {

  // .NewRetailPage {
  //   margin-top: 75px;
  // }
  .first-div {
    display: none;
  }

  .second-div {
    text-align: center;
    justify-content: center;
  }

  .section-2 {
    background: linear-gradient(90deg,
        rgba(236, 245, 255, 0.8) 61.27%,
        rgba(236, 245, 255, 0) 100%);
    display: flex;
    padding-top: 0px;
    padding-bottom: 0px;
    //flex-wrap: wrap;
  }

  .container .section-2 {
    border-radius: 0px;
    align-items: center;
  }

  .container .section-2 .sec-2wrap {
    flex-wrap: wrap;
    //padding-left: 30px;
    padding-right: 0px;
    margin-left: 0px;
    margin-right: 0px;
  }

  .section-2 .sec2 {
    padding-bottom: 0px;
    padding-top: 0px;
  }

  .section-2 .sec3 {
    padding-bottom: 0px;
    padding-top: 0px;
  }

  .section-2 .sec1 h1 {
    color: #2d2e8d;
    font-family: Poppins;
    font-size: 18px;
    font-weight: 700;
  }

  .section-2 .sec1 p {
    color: #000;
    font-size: 15px;
    font-weight: 600;
  }

  .section-2 .sec2 h1 {
    color: #2d2e8d;
    font-size: 18px;
    font-weight: 700;
    text-transform: capitalize;
  }

  .section-2 .sec2 span {
    color: #000;
    font-size: 15px;
    font-weight: 600;
    text-transform: capitalize;
  }

  .section-2 .sec3 span {
    color: #000;

    font-size: 15px;

    font-weight: 600;

    text-transform: capitalize;
  }

  .section-2 .sec3 h1 {
    color: #2d2e8d;
    font-size: 18px;
    font-weight: 700;
    text-transform: capitalize;
  }

  .steps {
    height: auto;
  }

  .div-heading {
    padding: 0 5%;
  }

  .section1 .sec33 {
    text-align: center;
  }

  .section1 .sec33 h1 {
    font-size: 25px;
    font-weight: 700px;
    margin-top: 10px;
    margin-bottom: 10px;
  }

  .section1 .sec33 p {
    font-size: 16px;
    font-weight: 500px;
    margin-bottom: 0px;
  }

  .section1 {
    padding: 0px;
    margin: 0px;
  }

  .sec2,
  .sec3 {
    flex-basis: 100%;
  }

  // below css for section div mob view

  .section .sec h1 {
    margin: 0px;
    font-size: 30px;
  }

  .section .sec p {
    text-align: center;
    font-size: 12px;
  }

  .section-3 .div-heading h1 {
    font-size: 20px;
  }

  //css for more link
  .partners-logo a {
    margin-top: 8px;
    margin-bottom: 8px;
  }

  .carousel-text h1 {
    text-align: center;
  }

  .carousel-text p {
    text-align: center;
  }

  .text-sec .left {
    justify-content: center;
    margin-left: 0px;
  }

  .faq-title {
    font-size: 20px;
  }

  // css for Faq button mobile view below collapse
  .custom-button {
    height: 30px;
    width: 90px;
    color: #2d2e8d;
    border: 1px solid #2d2e8d;
    background: #fff;
    font-size: 12px;
    border-radius: 5px;
    font-weight: 500;
  }
}

@media screen and (max-width: 930px) {
  .section1 .inner .text-sec {
    width: 35%;
  }

  .section1 .inner .img-sec {
    width: 65%;
  }
}

@media screen and (max-width: 1000px) {
  .section1 .inner {
    flex-direction: column;

    .text-sec {
      width: 90%;
      //text-align: center;
      // margin: 50px 0;
    }

    .img-sec {
      width: 100%;
    }
  }

  .section1 .inner-left {
    flex-direction: column;
  }

  .first-h1 {
    font-size: 30px;
  }

  .first-p {
    font-size: 14px;
  }

  .text-sec .stock-overview {
    padding-left: 0px;
  }

  .text-sec .stock-overview strong {
    font-size: 40px;
    font-weight: 600;
  }

  .text-sec .stock-overview h1 {
    font-size: 15px;
    font-weight: 600;
    margin-top: 10px;
    margin-bottom: 10px;
  }

  .text-sec .stock-overview span {
    font-size: 12px;
    font-weight: 500;
  }

  .text-sec .stock-overview p {
    font-size: 12px;
    font-weight: 500;
    padding-left: 60px;
  }

  /* Styles for mobile view for text img 2 section*/
  .show-for-desktop {
    display: none;
  }

  .show-for-mob {
    display: block;
  }
}

/* Styles for desktop view or text img 2 section*/
@media (min-width: 1001px) {
  .show-for-desktop {
    display: block;
  }

  .show-for-mob {
    display: none;
  }
}

@media screen and (max-width: 568px) {
  .section1 .inner .text-sec h2 {
    font-size: 2rem;
  }
}

@media screen and (max-width: 500px) {
  .first-h1 {
    font-size: 30px;
  }

  .first-p {
    font-size: 13px;
    margin-bottom: 5px;
  }

  .section1 {
    padding: 0 10px;

    .inner .img-sec .build-img {
      width: 100%;
    }
  }

 .chat-banner-launch .web-view {
    display: none !important;
  }

  .chat-banner-launch .mobile-view {
    display: block !important;
  }

  .features-top,
  .image-right,
  .bottom-text {
    flex: none;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 10px;
  }

  .features-list {
    padding: 0;
    margin: 0;
    display: flex;
    flex-direction: column;

    li {
      text-align: left;
      font-size: 12px;
      font-weight: 500;
    }
  }

  .text-left h2 {
    font-size: 20px;
  }

  .text-left {
    margin-top: 40px;
  }

  .highlighted {
    font-size: 15px;
  }

  .bottom-text {
    position: static;
    width: 100%;
    text-align: center;
    font-size: 7px;
    font-weight: 500;
    padding-bottom: 10px;
  }

  .banner {
    font-size: 10px;
    padding: 8px 15px;
    width: 60%;
  }

  .banner-image {
    top: 12px;
  }
}
</style>

<style lang="scss">
@import "../css/variable.scss";
@import "../css/common.scss";

.carousel-text1 {
  display: block;
}

.carousel-text2 {
  display: none;
}

.carousel-text3 {
  display: none;
}

.carousel-text h1 {
  color: #2d2e8d;
  font-family: Montserrat;
  font-size: 25px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  margin-bottom: 10px;
  margin-top: 10px;
  padding-left: 100px;
}

.carousel-text p {
  color: #656565;
  font-family: Montserrat;
  font-size: 15px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  padding-left: 100px;
}

// Below css for questions collapse section
.card-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  // margin-top: 30px;
  margin-bottom: 50px;
  margin: 30px;
}

.card {
  margin-bottom: 20px;
  max-width: 650px;
  width: 100%;
  border-radius: 10px;
}

.card-container .card .question {
  font-size: 18px;
  font-weight: 600;
}

.card-container .card .answer {
  font-size: 15px;
  font-weight: 500;
}

@media (max-width: 768px) {
  .carousel-text h1 {
    text-align: center;
    padding-left: 0px;
  }

  .carousel-text p {
    text-align: center;
    padding-left: 0px;
  }

  .text-sec .left {
    justify-content: center;
    margin-left: 0px;
  }

  // css for collapse questions
  .card-container .card .question {
    font-size: 12px;
    font-weight: 600;
  }

  .card-container .card .answer {
    font-size: 10px;
    font-weight: 500;
  }
}

// below css for carousel section
.section5 {
  margin: 100px 50px;

  .Carousel-mobile {
    display: none;
  }

  .image-outer {
    width: 50%;
    display: flex;
    justify-content: center;
  }

  h3 {
    font-size: 1.8rem;
    text-align: center;
    text-transform: uppercase;
  }

  .emp-card-section {
    display: flex;
    justify-content: space-around;

    .emp-card {
      max-width: 400px;
      text-align: center;
      position: relative;
      margin: 10px 20px;

      .card1 {
        height: 80px;
      }

      img {
        width: 125px;
        position: absolute;
        top: 25px;
      }
    }
  }
}

// Below css for questions collapse section
.card-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  // margin-top: 30px;
  margin-bottom: 50px;
  margin: 30px;
}

.card {
  margin-bottom: 20px;
  max-width: 650px;
  width: 100%;
  border-radius: 10px;
}

.el-collapse-item__header {
  border-bottom: none !important;
}

.custom-button {
  height: 40px;
  width: 110px;
  background: rgba(255, 255, 255, 0);
  //box-shadow: 0px 0px 30px 0px rgba(103, 103, 103, 0.2);
  border: 0.8px solid #000;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 16px;
  cursor: pointer;
  border-radius: 10px;
  color: #000;
  font-family: Montserrat;
  font-size: 15px;
  font-style: normal;
  font-weight: 500;
  line-height: 159.523%;
}
</style>